

export const formatDateToString = (date: Date, type: number = 0): string => {
    const year = date.getFullYear().toString().padStart(4, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const formatDate = (date: Date | string | undefined, type: number): string => {
  if (!date) return ''
  if (typeof date == 'string') date = new Date(date)
  if (type == 1) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  } else if (type == 2) {
    const year: number = date.getFullYear()
    const month: number = date.getMonth() + 1
    return `${year}年${month}月`
  } else if (type == 3) {
    const year: number = date.getFullYear()
    const month: number = date.getMonth() + 1
    const day: number = date.getDate()
    return `${year}年${month}月${day}日`
  }
  return ''

}